import { render } from "./tree.vue?vue&type=template&id=57bf5e2e&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-57bf5e2e"

export default script